import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MonitorHeartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"monitor_heart"}/>
}
